import api from '../utils/API';

/**
 * Existing CRM candidates matching a person about to be added.
 * Each match has `match`: 'linkedin' (same profile) | 'name_company' | 'name'.
 */
export const checkCandidatDuplicate = ({ linkedin, prenom, nom, employeur }) =>
  api
    .get('/candidatsmanagement/candidat/duplicates/check', {
      params: { linkedin: linkedin || undefined, prenom: prenom || undefined, nom: nom || undefined, employeur: employeur || undefined },
    })
    .then((res) => res.data?.matches || []);
